export type FinanceDeepLink = {
  id?: number;
  orderNo?: string;
  mode: 'view' | 'edit';
};

export const parseFinanceDeepLink = (
  searchParams: Pick<URLSearchParams, 'get'>,
): FinanceDeepLink | null => {
  const rawId = searchParams.get('id')?.trim();
  const parsedId = rawId && /^\d+$/.test(rawId) ? Number(rawId) : undefined;
  const id =
    parsedId != null && Number.isSafeInteger(parsedId) && parsedId > 0
      ? parsedId
      : undefined;
  const orderNo = searchParams.get('orderNo')?.trim();
  if (id == null && !orderNo) return null;
  return {
    ...(id != null ? { id } : {}),
    ...(orderNo ? { orderNo } : {}),
    mode: searchParams.get('mode') === 'edit' ? 'edit' : 'view',
  };
};

export const findFinanceDeepLinkRow = <T extends { billNo?: unknown }>(
  rows: T[],
  orderNo: string,
): T | undefined =>
  rows.find((row) => String(row.billNo ?? '') === orderNo);
